module.exports = __webpack_public_path__ + "static/media/salada.1b5e1bbb.jpg";